// src/components/PluggyConnectComponent.tsx
import React, { useEffect, useState } from "react";
import { PluggyConnect } from "react-pluggy-connect";
import axios from "axios";

const PluggyConnectComponent: React.FC = () => {
  const [connectToken, setConnectToken] = useState<string | null>(null);
useEffect(() => {
  axios
    .get("http://localhost:8080/pluggy/connect-token")
    .then((res) => {
      if (res.data.connectToken) {
        setConnectToken(res.data.connectToken);
      } else {
        console.error("Resposta inesperada: connectToken ausente", res.data);
      }
    })
    .catch((err) => {
      console.error("Erro ao buscar connectToken:", err);
    });
}, []);

  return (
    <div>
      {connectToken ? (
        <PluggyConnect
          connectToken={connectToken}
          includeSandbox={true}
          connectorTypes={["PERSONAL_BANK"]}
          language="pt"
          onSuccess={({ item }) => console.log("Conectado com sucesso:", item)}
          onError={(error) => console.error("Erro ao conectar:", error)}
          onOpen={() => console.log("Widget Pluggy aberto")}
          onClose={() => console.log("Widget Pluggy fechado")}
          onEvent={(event) => console.log("Evento recebido:", event)}
        />
      ) : (
        <p>Carregando Pluggy Connect...</p>
      )}
    </div>
  );
};

export default PluggyConnectComponent;
